import { 
	SET_VARIABLE_LIST,
	SET_VARIABLE_ITEM,
	SET_FILTRED_VARIABLE_LIST
} from "./actions/KPI/actions";

const initialState = {
	_variableList: null,
	_filtredVariableList: null,
};
const variableReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_VARIABLE_LIST:
			return {
				...state,
				_variableList: action.payload
			};
		case SET_VARIABLE_ITEM:
			return {
				...state,
				_variableList: state._variableList.map(item => 
				  	item.id === action.payload.id ? action.payload : item
				)
			};
		case SET_FILTRED_VARIABLE_LIST:
			return {
				...state,
				_filtredVariableList: action.payload
			};
		default:
			return state;
	}
};

export default variableReducer;